<template>
  <div>
    <div class="row mt-5">
      <div class="col-lg-12">
        <img
          src="../assets/photos/about.png"
          alt="Hakkımızda"
          class="w-100 img-fluid"
          id="shadow"
        />
      </div>
    </div>
    <div class="row mt-5" v-scrollanimation>
      <div class="col-lg-12">
        <p class="text-center"><strong>Biz Kimiz ?</strong></p>
        <span>
          <p class="text-center">
            <strong>Ayancık Adak</strong> , Ergin ve Ersin TURAN kardeşler
            tarafından uzun yıllardan beri Sinop / Ayancık ve çevresinde hizmet
            veren bir kuruluştur. Siz değerli müşterilerimize hijyen ve islami
            kurallara uygun bir şekilde hizmet sunmak birinci önceliğimizdir.
          </p>
          <div class="card col-lg-6 col-sm-6 mx-auto mt-5">
            <p class="card-title text-center mt-3">Hizmetlerimiz</p>
            <hr />
            <div class="card-body">
              <ul>
                <li>Kurbanlık Satışı</li>
                <li>Adaklık Satışı</li>
                <li>Satış Sonrası Kesim ( Ücretsiz )</li>
                <li>Evlerde Kesim</li>
                <li>Hayvan Nakliyatı</li>
              </ul>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
span > p {
  font-size: 20px;
}
p {
  font-family: "Nunito Sans", sans-serif;
  font-size: 45px;
  font-weight: 500;
}

ul > li {
  font-size: 25px;
  list-style-type: square;
}
#shadow {
  border-radius: 5px;
  -webkit-box-shadow: 0px 2px 30px 10px rgba(0, 0, 0, 0.53);
  -moz-box-shadow: 0px 2px 30px 10px rgba(0, 0, 0, 0.53);
  box-shadow: 0px 2px 30px 10px rgba(0, 0, 0, 0.53);
}

.before-enter {
  opacity: 0;
  transform: scale(0);
  transition: all 0.5s ease-in;
}
.enter {
  opacity: 1;
  transform: scale(1);
}

@media only screen and (max-width: 360px) {
  .card-title {
    font-size: 41px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue